import { createSelector } from 'reselect'
import getRouteAndMatchRouterSelect from 'modules/router/selectors/get-route-and-match/index.js'

export const isAnAppRouteSelect = createSelector(
  getRouteAndMatchRouterSelect,
  ({ route }) => {
    return !!route?.isApp
  }
)
